/**
 * @file Blog related queries for Web Galleries.
 */

import gql from 'graphql-tag';

import { BlogPostDetails } from '../fragments/blog';

export const BlogPost = gql`
  query blogPost($id: RecordID!) {
    blogPost(id: $id) {
      id
      ...BlogPostDetails
    }
  }
  ${BlogPostDetails}
`;
